export default {
    title: "Katalog",
    noAvailableItems: "Brak produktów do zamówienia."
}